<div class="container py-3">
  <div class="card">
    <div class="card-body p-5">
      @for (historyItem of historyItemsQuery | async; track historyItem.eventId; let first = $first) {
        <div class="row mb-3">
          <div class="col-auto text-end" [style.width.px]="150">
            @if (splitTimeAndDate(historyItem.timestamp | calendar); as timestampFormatted) {
              <span class="d-block">{{ timestampFormatted[0] }}</span>
              <span class="d-block">{{ timestampFormatted[1] }}</span>
            }
          </div>
          <div class="d-flex col-auto">
            <div class="d-flex align-items-center border border-info rounded-circle justify-content-center"
                 style="width: 1.5rem; height: 1.5rem;" [ngClass]="first ? 'border-2' : ''">
              @if (first) {
                <div class="d-flex bg-info rounded-circle" style="width: 0.9rem; height: 0.9rem;">
                </div>
              }
            </div>
          </div>
          <div class="col">
            @if (appContext.isAdmin()) {
              <div class="d-block position-relative">
                <a class="mb-1 underline-tertiary link-underline-tertiary link-primary text-body" target="_blank"
                   [href]="portVisitUtils.getKibanaLink(historyItem.traceId, historyItem.timestamp)">
                  <span class="h2 m-0">
                    <span>{{ historyItem.action }} {{ historyItem.source ? '(' + historyItem.source + ')' : '' }}</span>
                    <i class="fa fa-arrow-up fa-rotate-by me-2" style="--fa-rotate-angle: 45deg; font-size: 0.75rem;"
                       aria-hidden="true"></i>
                  </span>
                </a>
                @if (openInEmhEnabled(historyItem)) {
                  <button class="btn btn-plain h2 m-0 p-0"
                          (click)="portVisitUtils.redirectToMessageManagement(historyItem.emhProcessId)">
                    <i class="fa fa-inbox ps-1 link-primary text-muted" aria-hidden="true"></i>
                  </button>
                }
              </div>
            } @else {
              <div class="d-block mb-1">
                <span class="h2 m-0 position-relative">
                  <span>{{ historyItem.action }}</span>
                </span>
              </div>
            }
            <span class="d-block text-secondary mb-1">{{ formatUser(historyItem) }}</span>
            <span class="d-block">{{ historyItem.messages | join }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
